// src/components/steps/GenderStep.js
import React from 'react';
import {
  VStack,
  Text,
  Box,
  HStack,
  Button,
} from '@chakra-ui/react';
import { UserCircle2 } from 'lucide-react';

const genderOptions = [
    { 
      value: 'boy', 
      label: '男の子',
      color: 'blue.400',
      icon: <UserCircle2 size={36} strokeWidth={1.5} />  // 直接サイズを指定
    },
    { 
      value: 'girl', 
      label: '女の子',
      color: 'pink.400',
      icon: <UserCircle2 size={36} strokeWidth={1.5} />  // 直接サイズを指定
    }
  ];

const GenderStep = ({ formData, onChange }) => {
  return (
    <VStack spacing={{ base: 6, md: 8 }} align="stretch">
      <Text 
        fontSize={{ base: "xl", md: "2xl" }}
        fontWeight="bold" 
        textAlign="center"
        bgGradient="linear(to-r, blue.400, pink.400)"
        bgClip="text"
        mb={{ base: 4, md: 6 }}
      >
        お子様の性別を教えてください
      </Text>
      
      <Box>
        <HStack 
          spacing={{ base: 3, md: 4 }} 
          justify="center"
          flexDirection={{ base: "column", sm: "row" }}
        >
          {genderOptions.map((option) => (
            <Button
            key={option.value}
            onClick={() => onChange({
              target: { name: 'gender', value: option.value }
            })}
            size="lg"
            height={{ base: "100px", md: "120px" }}
            width={{ base: "100%", sm: "200px" }}
            bg={formData.gender === option.value ? option.color : 'white'}
            color={formData.gender === option.value ? 'white' : 'gray.600'}
            _hover={{ 
              bg: option.color, 
              color: 'white',
              transform: 'translateY(-2px)',
              transition: 'all 0.2s'
            }}
            border="2px"
            borderColor={option.color}
            borderRadius="xl"
            display="flex"
            flexDirection="column"
            gap={2}
          >
            <Box 
                color={formData.gender === option.value ? 'white' : option.color}
                transition="all 0.2s"
                >
              {option.icon}
            </Box>
            <Text 
              fontSize={{ base: "lg", md: "xl" }}
              transition="all 0.2s"
            >
              {option.label}
            </Text>
          </Button>
          ))}
        </HStack>
      </Box>

      <Box 
        mt={{ base: 6, md: 8 }}
        p={{ base: 4, md: 6 }} 
        bg="blue.50" 
        borderRadius="xl"
        borderLeft="4px"
        borderColor="blue.400"
      >
        <Text 
          color="blue.600"
          fontSize={{ base: "sm", md: "md" }}
        >
          お子様の性別に合わせて、最適なランドセルを見つけるお手伝いをします。
        </Text>
      </Box>
    </VStack>
  );
};

export default GenderStep;